export default class RebanhoDeReproducao {

    constructor(formulario = '') {
        this.touroPesoMedio = formulario.touroPesoMedio == undefined ? 0 : formulario.touroPesoMedio;
        this.touroCabecaInicial = formulario.touroCabecaInicial == undefined ? 0 : formulario.touroCabecaInicial;
        this.touroCabecaFinal = formulario.touroCabecaFinal  == undefined ? 0 : formulario.touroCabecaFinal;
        this.touroValor = formulario.touroValor == undefined ? 0 : formulario.touroValor;
        this.vacaMatrizPesoMedio = formulario.vacaMatrizPesoMedio == undefined ? 0 : formulario.vacaMatrizPesoMedio;
        this.vacaMatrizCabecaInicial = formulario.vacaMatrizCabecaInicial == undefined ? 0 : formulario.vacaMatrizCabecaInicial;
        this.vacaMatrizCabecaFinal = formulario.vacaMatrizCabecaFinal == undefined ? 0 : formulario.vacaMatrizCabecaFinal;
        this.vacaMatrizValor = formulario.vacaMatrizValor == undefined ? 0 : formulario.vacaMatrizValor;
    }
}